// msalInstance.js — shared MSAL instance
// Place in: reporting-frontend/src/msalInstance.js

import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);
